// @flow

function getCookie (name: string): ?string {
  let value = '; ' + document.cookie
  let parts = value.split('; ' + name + '=')
  if (parts.length === 2) {
    return parts
      .pop()
      .split(';')
      .shift()
  }
}

function setCookie (name: string, value: string, minutes?: number) {
  var expires = ''
  if (minutes) {
    var date = new Date()
    date.setTime(date.getTime() + minutes * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + value + expires + '; path=/'
}

export { getCookie, setCookie }



// WEBPACK FOOTER //
// ./src/frame/core/cookie.js